<template>
  <section class="lpg-main">
    <Head title="Editar Perfil"></Head>
    <div class="container-fluid px-0 mb-5">
      <div class="position-relative lpg-profile-cv">
        <div class="row g-0">
          <!-- left side -->
          <div class="col-12 col-md-4 col-lg-4 col-xl-3 px-4 pb-4 lpg-bg-green">
            <div class="d-flex justify-content-center align-items-center">
              <div class="d-flex flex-column">
                <div class="mt-5 mb-3 text-center d-block mx-auto">
                  <!-- for tag on label must equal to input file id tag -->
                  <div class="profile-pic" @click="pickFile('logo_pic_file')">
                    <img :src="logo_pic_url" />
                    <div class="pic-overlay">Cambiar foto de perfil</div>
                    <input
                      id="logo_pic_file"
                      name="logo_pic_file"
                      type="file"
                      class="d-none"
                      accept="image/*"
                      ref="logo_pic_file"
                      @change="fileSelected($event, 'logo_pic')"
                    />
                  </div>
                </div>
                <div class="mb-4 text-center">
                  <h2 class="mt-2 lpg-form-title fs-4">{{ company.name }}</h2>
                </div>
              </div>
            </div>

            <div class="lpg-form lpg-form-box px-0">
              <section>
                <div
                  class="lpg-profile-content row row-cols-1 row-cols-md-1 gy-2 justify-content-center"
                >
                  <text-input
                    id="website_url"
                    v-model="form.website_url"
                    label="Sitio Web"
                    icon="bi bi-globe"
                    icon_color="#8e8e8e"
                  />
                  <text-input
                    id="fb_url"
                    v-model="form.fb_url"
                    label="Facebook"
                    icon="bi bi-facebook"
                    icon_color="#8e8e8e"
                  />
                  <text-input
                    id="fb_url"
                    v-model="form.ig_url"
                    label="Instagram"
                    icon="bi bi-instagram"
                    icon_color="#8e8e8e"
                  />
                  <text-input
                    id="fb_url"
                    v-model="form.linkedin_url"
                    label="LinkedIn"
                    icon="bi bi-linkedin"
                    icon_color="#8e8e8e"
                  />
                </div>
              </section>
            </div>
          </div>

          <!-- right side -->
          <div class="col-12 col-md col-lg text-start bg-white">
            <!-- Start header with image -->
            <div
              class="lpg-header position-relative d-none d-md-block"
              @click="pickFile('header_pic_file')"
            >
              <img
                :src="
                  header_pic_url
                    ? header_pic_url
                    : 'https://via.placeholder.com/1414x315/FFFFFF/000000?text=Agregar+banner'
                "
                class="img-fluid vw-100"
                alt="..."
              />
              <div class="pic-overlay">
                {{ header_pic_url ? 'Cambiar' : 'Agregar' }} foto de banner
              </div>
              <input
                id="header_pic_file"
                name="header_pic_file"
                type="file"
                class="d-none"
                accept="image/*"
                ref="header_pic_file"
                @change="fileSelected($event, 'header_pic')"
              />
            </div>
            <!-- End header with image -->

            <div class="lpg-body-side-right">
              <div class="lpg-form lpg-form-box px-0">
                <div class="row mt-2">
                  <div class="col-12 text-center text-md-end">
                    <button
                      class="btn btn-secondary mx-auto"
                      :disabled="_form.processing || Object.keys(changes).length === 0"
                      @click.prevent="submitChanges"
                    >
                      <span
                        :class="{
                          'visually-hidden': !uploading_changes,
                          'spinner-border spinner-border-sm': true,
                        }"
                        role="status"
                        aria-hidden="true"
                      ></span>
                      <BS-Icon
                        :class="[
                          'bi bi-check2-square pe-3',
                          { 'visually-hidden': uploading_changes },
                        ]"
                        style="font-size: 1.5rem"
                        _label="update icon"
                      />
                      Guardar cambios
                    </button>
                  </div>
                </div>

                <section>
                  <h2 class="mt-5 lpg-form-title no-letter-spacing">Descripción</h2>

                  <div class="lpg-profile-content">
                    <div class="card lpg-card lpg-card-white p-0 mb-3">
                      <textarea-input
                        id="description"
                        v-model="form.description"
                        :maxlength="500"
                      ></textarea-input>
                    </div>
                  </div>
                </section>

                <div class="row">
                  <div class="col-12 col-lg-6">
                    <section>
                      <h2 class="mt-5 lpg-form-title no-letter-spacing">Misión</h2>

                      <div class="lpg-profile-content">
                        <div class="card lpg-card lpg-card-white p-0 mb-3">
                          <textarea-input
                            id="company_mission"
                            v-model="form.company_mission"
                            :maxlength="300"
                          ></textarea-input>
                        </div>
                      </div>
                    </section>
                  </div>
                  <div class="col-12 col-lg-6">
                    <section>
                      <h2 class="mt-5 lpg-form-title no-letter-spacing">Visión</h2>

                      <div class="lpg-profile-content">
                        <div class="card lpg-card lpg-card-white p-0 mb-3">
                          <textarea-input
                            id="company_vision"
                            v-model="form.company_vision"
                            :maxlength="300"
                          ></textarea-input>
                        </div>
                      </div>
                    </section>
                  </div>
                </div>

                <section>
                  <h2 class="mt-5 lpg-form-title no-letter-spacing">Valores</h2>

                  <div class="lpg-profile-content">
                    <div class="card lpg-card lpg-card-white p-0 mb-3">
                      <textarea-input
                        id="company_values"
                        v-model="form.company_values"
                        :maxlength="300"
                      ></textarea-input>
                    </div>
                  </div>
                </section>
                <hr class="mt-5" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { Link, Head } from '@inertiajs/inertia-vue'
import LayoutEmpresas from '@/Layouts/LayoutEmpresas'
import SidebarLinkItem from '@/Components/SidebarLinkItem'
import Icon from '@/Components/BS-Icon'
import TextInput from '@/Components/Form/TextInput'
import TextareaInput from '@/Components/Form/TextareaInput'

export default {
  name: 'EmpresaPerfilEdit',
  layout: LayoutEmpresas,
  components: { Head, Link, SidebarLinkItem, Icon, TextInput, TextareaInput },
  props: {
    company: Object,
    errors: Object,
  },
  data() {
    return {
      uploading_changes: false,
      logo_pic_url: this.company.logo_url,
      header_pic_url: this.company.header_url,
      form: {
        name: this.company.name,
        description: this.company.description,
        company_mission: this.company.company_mission,
        company_vision: this.company.company_vision,
        company_values: this.company.company_values,
        website_url: this.company.website_url,
        fb_url: this.company.fb_url,
        ig_url: this.company.ig_url,
        linkedin_url: this.company.linkedin_url,
        company_size_id: this.company.company_size_id,
        company_category_id: this.company.company_category_id,
        logo_pic: null,
        header_pic: null,
      },
    }
  },
  methods: {
    submitChanges() {
      this._form.post(this.$route('company.profile.update'), {
        onSuccess: page => {
          console.log('On Success callback')
          if (Object.keys(page.props.errors).length === 0) {
            this.$swal.fire({ title: '¡Se ha actualizado el perfil!', icon: 'success' })
          }
        },
        onError: () => {
          console.log('On Error callback')
          this.$swal.fire({
            title: 'Error de validación',
            icon: 'warning',
            html:
              '<ul class="text-start fs-6">' +
              Object.values(this.errors).reduce((prev, curr) => (prev += `<li>${curr}</li>`), '') +
              '</ul>',
          })
        },
      })
    },
    pickFile(id = null) {
      if (id) this.$refs[id].click()
    },
    fileSelected(event, element_id) {
      // Create instance of FileReader
      const fileReader = new FileReader()
      // Get the uploaded file from input element
      const file = event.target.files[0]
      // Add File object to our form data
      this.form[element_id] = file

      // Add event listener for when the file reader has loaded and read the file
      fileReader.addEventListener(
        'load',
        () => {
          this[element_id + '_url'] = fileReader.result
        },
        false,
      )

      // If file exists, tell file reader to start reading the file
      if (file) fileReader.readAsDataURL(file)
    },
  },
  computed: {
    changes() {
      const textFormFields = [
        'name',
        'description',
        'company_mission',
        'company_vision',
        'company_values',
        'website_url',
        'fb_url',
        'ig_url',
        'linkedin_url',
        'company_size_id',
        'company_category_id',
      ]

      // Filter only changed values
      let formChanges = Object.entries(this.form)
        .filter(([key, value]) => textFormFields.includes(key) && value !== this.company[key])
        .reduce((obj, value) => {
          obj[value[0]] = value[1]
          return obj
        }, {})

      // Post update
      if (this.form.logo_pic) formChanges.logo_url = this.form.logo_pic
      if (this.form.header_pic) formChanges.header_url = this.form.header_pic

      return formChanges
    },
    _form() {
      return this.$inertia.form({ _method: 'put', ...this.changes })
    },
  },
}
</script>

<style lang="scss" scoped>
.pic-overlay {
  position: absolute;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  color: #d4d4d4;
  width: 100%;
  transition: 0.5s ease;
  opacity: 1;
  font-size: 20px;
  padding: 10px 50px;
  padding-bottom: 20px;
  word-wrap: break-word;
  text-align: center;
  box-shadow: 0px -20px 20px 0px rgba(0, 0, 0, 0.5);
  -webkit-box-shadow: 0px -20px 20px 0px rgba(0, 0, 0, 0.5);
  -moz-box-shadow: 0px -20px 20px 0px rgba(0, 0, 0, 0.5);

  &:hover {
    background: rgba(0, 0, 0, 0.7);
    box-shadow: 0px -30px 30px -0px rgba(0, 0, 0, 0.7);
    -webkit-box-shadow: 0px -30px 30px -0px rgba(0, 0, 0, 0.7);
    -moz-box-shadow: 0px -30px 30px -0px rgba(0, 0, 0, 0.7);
    font-weight: bold;
    transition: 0.5s ease;
  }
}

.profile-pic {
  position: relative;
  border-radius: 50%;
  overflow: hidden;
  width: 300px;
  height: 300px;
  border: solid grey 5px;
  &:hover {
    cursor: pointer;

    .pic-overlay {
      background: rgba(0, 0, 0, 0.7);
      box-shadow: 0px -30px 30px -0px rgba(0, 0, 0, 0.7);
      -webkit-box-shadow: 0px -30px 30px -0px rgba(0, 0, 0, 0.7);
      -moz-box-shadow: 0px -30px 30px -0px rgba(0, 0, 0, 0.7);
      font-weight: bold;
      transition: 0.5s ease;
    }
  }

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
  }
}

.lpg-header {
  &:hover {
    cursor: pointer;
    .pic-overlay {
      background: rgba(0, 0, 0, 0.7);
      box-shadow: 0px -30px 30px -0px rgba(0, 0, 0, 0.7);
      -webkit-box-shadow: 0px -30px 30px -0px rgba(0, 0, 0, 0.7);
      -moz-box-shadow: 0px -30px 30px -0px rgba(0, 0, 0, 0.7);
      font-weight: bold;
      transition: 0.5s ease;
    }
  }
}
</style>
